import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "source", "button" ]
  static classes = [ "supported" ]
  static values = {
    successDuration: {
      type: Number,
      default: 2000
    }
  }

  connect() {
    if ("clipboard" in navigator) {
      this.element.classList.add(this.supportedClass);

      if (!this.hasButtonTarget) return

      this.originalText = this.buttonTarget.textContent;
    }
  }

  copy(event) {
    event.preventDefault()

    const button = event.currentTarget
    navigator.clipboard.writeText(this.sourceTarget.value || this.sourceTarget.textContent).then(() => {
      this.copied()
      button.blur()
    })
  }

  copied() {
    if (!this.hasButtonTarget) return

    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.buttonTarget.innerText = this.data.get('successContent')

    this.timeout = setTimeout(() => {
      this.buttonTarget.innerText = this.originalText
    }, this.successDurationValue)
  }
}
